// import pictureQuestion from "../../img/pictureQuestion.png";
// import "./mainPage.css";
// import { useState, useEffect } from "react";
// import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";
// import { doc, updateDoc } from "firebase/firestore";
// import { db } from "../../firebase";
// import Swal from "sweetalert2";

// const Question = () => {
//   const [surveys, setSurveys] = useState([]);
//   const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);
//   const [totalVotes, setTotalVotes] = useState(0);
//   const [showResults, setShowResults] = useState(false);
//   const [hasVoted, setHasVoted] = useState(false);

//   useEffect(() => {
//     const fetchLatestSurvey = async () => {
//       try {
//         // Отримання найновішого опитування
//         const surveysRef = collection(db, "surveys");
//         const latestSurveyQuery = query(
//           surveysRef,
//           orderBy("data", "desc"),
//           limit(1)
//         );
//         const surveySnapshot = await getDocs(latestSurveyQuery);

//         if (!surveySnapshot.empty) {
//           const latestSurvey = surveySnapshot.docs[0].data();
//           setSurveys([{ id: surveySnapshot.docs[0].id, ...latestSurvey }]);

//           // Підрахунок загальної кількості голосів
//           const initialTotalVotes = latestSurvey.options
//             .filter((option) => option.text !== "")
//             .reduce((acc, option) => acc + option.score, 0);
//           setTotalVotes(initialTotalVotes);
//         }
//       } catch (error) {
//         console.error("Помилка під час отримання опитування: ", error);
//       }
//     };

//     fetchLatestSurvey();
//   }, []);

//   const handleOptionClick = (optionIndex) => {
//     setSelectedOptionIndex(optionIndex);
//   };

//   const handleVoteClick = async () => {
//     if (selectedOptionIndex !== null) {
//       setSurveys((prevSurveys) => {
//         const updatedSurveys = [...prevSurveys];
//         const selectedOption = updatedSurveys[0].options[selectedOptionIndex];

//         // Збільшити обране значення на 1
//         selectedOption.score += 1;

//         // Оновити значення в Firebase
//         const surveyDocRef = doc(db, "surveys", updatedSurveys[0].id);
//         updateDoc(surveyDocRef, { options: updatedSurveys[0].options })
//           .then(() => {
//             Swal.fire({
//               title: "Дякуємо за ваш голос!",
//               text: "Ваша думка важлива для нас.",
//               icon: "success",
//               confirmButtonText: "ОК",
//               confirmButtonColor: "#609966",
//             });
//             setHasVoted(true);
//           })
//           .catch((error) => {
//             console.error("Помилка під час оновлення документа: ", error);
//             Swal.fire({
//               title: "Помилка!",
//               text: "Сталася помилка під час голосування. Спробуйте ще раз.",
//               icon: "error",
//               confirmButtonText: "ОК",
//               confirmButtonColor: "#d33",
//             });
//           });

//         // Оновлення загальної кількості голосів
//         const newTotalVotes = totalVotes + 1;
//         setTotalVotes(newTotalVotes);
//         setShowResults(true);

//         return updatedSurveys;
//       });
//     } else {
//       Swal.fire({
//         title: "Помилка!",
//         text: "Будь ласка, виберіть один із варіантів для голосування.",
//         icon: "error",
//         confirmButtonText: "ОК",
//         confirmButtonColor: "#d33",
//       });
//     }
//   };

//   return (
//     <div className="questionWrap">
//       {surveys.length > 0 && (
//         <div className="questionWrapSmall">
//           <div className="pictureAnswerWrap">
//             <img
//               src={surveys[0].imageURL || pictureQuestion}
//               className="pictureAnswer"
//               alt={surveys[0].title}
//             />
//           </div>

//           <div className="wrapBlockAw">
//             {" "}
//             <h1 className="questionSinc">Яка ваша думка?</h1>
//             <div className="questionsWrap">
//               <p className="descriptionQuestion">{surveys[0].description}</p>
//               {surveys[0].options
//                 .filter((option) => option.text !== "")
//                 .map((option, index) => {
//                   const percentage = totalVotes
//                     ? ((option.score / totalVotes) * 100).toFixed(1)
//                     : 0;
//                   return (
//                     <div className="QuestionUl" key={index}>
//                       <div
//                         className={`checkQuestion ${
//                           selectedOptionIndex === index
//                             ? hasVoted
//                               ? "greenButtonCheck"
//                               : "selected"
//                             : ""
//                         }`}
//                         onClick={() => handleOptionClick(index)}
//                       ></div>
//                       {showResults && (
//                         <span className="percentage">{percentage}%</span>
//                       )}
//                       <p className="questionLi">{option.text}</p>
//                     </div>
//                   );
//                 })}
//               {!hasVoted && (
//                 <button className="questionButton" onClick={handleVoteClick}>
//                   Проголосувати
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Question;
import pictureQuestion from "../../img/pictureQuestion.png";
import "./mainPage.css";
import { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
  doc,
  runTransaction,
} from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";

const VOTE_STORAGE_PREFIX = "survey_vote_";

const Question = () => {
  const [surveys, setSurveys] = useState([]);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);
  const [totalVotes, setTotalVotes] = useState(0);
  const [showResults, setShowResults] = useState(false);
  const [hasVoted, setHasVoted] = useState(false);

  const getVoteStorageKey = (surveyId) => {
    return `${VOTE_STORAGE_PREFIX}${surveyId}`;
  };

  const getSavedVote = (surveyId) => {
    try {
      const savedVote = localStorage.getItem(getVoteStorageKey(surveyId));
      return savedVote ? JSON.parse(savedVote) : null;
    } catch (error) {
      console.error("Помилка читання localStorage:", error);
      return null;
    }
  };

  const saveVoteToLocalStorage = (surveyId, optionIndex) => {
    try {
      localStorage.setItem(
        getVoteStorageKey(surveyId),
        JSON.stringify({
          surveyId,
          optionIndex,
          votedAt: new Date().toISOString(),
        }),
      );
    } catch (error) {
      console.error("Помилка запису в localStorage:", error);
    }
  };

  useEffect(() => {
    const fetchLatestSurvey = async () => {
      try {
        const surveysRef = collection(db, "surveys");

        const latestSurveyQuery = query(
          surveysRef,
          orderBy("data", "desc"),
          limit(1),
        );

        const surveySnapshot = await getDocs(latestSurveyQuery);

        if (!surveySnapshot.empty) {
          const surveyDoc = surveySnapshot.docs[0];

          const latestSurvey = {
            id: surveyDoc.id,
            ...surveyDoc.data(),
          };

          setSurveys([latestSurvey]);

          const initialTotalVotes = latestSurvey.options
            .filter((option) => option.text !== "")
            .reduce((acc, option) => acc + Number(option.score || 0), 0);

          setTotalVotes(initialTotalVotes);

          const savedVote = getSavedVote(latestSurvey.id);

          if (savedVote) {
            setHasVoted(true);
            setShowResults(true);
            setSelectedOptionIndex(savedVote.optionIndex);
          } else {
            setHasVoted(false);
            setShowResults(false);
            setSelectedOptionIndex(null);
          }
        }
      } catch (error) {
        console.error("Помилка під час отримання опитування: ", error);
      }
    };

    fetchLatestSurvey();
  }, []);

  const handleOptionClick = (optionIndex) => {
    if (hasVoted) return;

    setSelectedOptionIndex(optionIndex);
  };

  const handleVoteClick = async () => {
    if (!surveys.length) return;

    const currentSurvey = surveys[0];

    const savedVote = getSavedVote(currentSurvey.id);

    if (savedVote) {
      setHasVoted(true);
      setShowResults(true);
      setSelectedOptionIndex(savedVote.optionIndex);

      Swal.fire({
        title: "Ви вже голосували",
        text: "За одне опитування можна проголосувати тільки один раз.",
        icon: "info",
        confirmButtonText: "ОК",
        confirmButtonColor: "#3e3092",
      });

      return;
    }

    if (selectedOptionIndex === null) {
      Swal.fire({
        title: "Помилка!",
        text: "Будь ласка, виберіть один із варіантів для голосування.",
        icon: "error",
        confirmButtonText: "ОК",
        confirmButtonColor: "#d33",
      });

      return;
    }

    try {
      const surveyDocRef = doc(db, "surveys", currentSurvey.id);

      await runTransaction(db, async (transaction) => {
        const surveyDoc = await transaction.get(surveyDocRef);

        if (!surveyDoc.exists()) {
          throw new Error("Опитування не знайдено");
        }

        const surveyData = surveyDoc.data();

        const updatedOptions = [...surveyData.options];

        if (!updatedOptions[selectedOptionIndex]) {
          throw new Error("Варіант відповіді не знайдено");
        }

        updatedOptions[selectedOptionIndex] = {
          ...updatedOptions[selectedOptionIndex],
          score: Number(updatedOptions[selectedOptionIndex].score || 0) + 1,
        };

        transaction.update(surveyDocRef, {
          options: updatedOptions,
        });
      });

      const updatedSurveys = [...surveys];

      updatedSurveys[0].options = updatedSurveys[0].options.map(
        (option, index) => {
          if (index === selectedOptionIndex) {
            return {
              ...option,
              score: Number(option.score || 0) + 1,
            };
          }

          return option;
        },
      );

      setSurveys(updatedSurveys);
      setTotalVotes((prev) => prev + 1);
      setShowResults(true);
      setHasVoted(true);

      saveVoteToLocalStorage(currentSurvey.id, selectedOptionIndex);

      Swal.fire({
        title: "Дякуємо за ваш голос!",
        text: "Ваша думка важлива для нас.",
        icon: "success",
        confirmButtonText: "ОК",
        confirmButtonColor: "#609966",
      });
    } catch (error) {
      console.error("Помилка під час голосування: ", error);

      Swal.fire({
        title: "Помилка!",
        text: "Сталася помилка під час голосування. Спробуйте ще раз.",
        icon: "error",
        confirmButtonText: "ОК",
        confirmButtonColor: "#d33",
      });
    }
  };

  return (
    <div className="questionWrap">
      {surveys.length > 0 && (
        <div className="questionWrapSmall">
          <div className="pictureAnswerWrap">
            <img
              src={surveys[0].imageURL || pictureQuestion}
              className="pictureAnswer"
              alt={surveys[0].title || "Опитування"}
            />
          </div>

          <div className="wrapBlockAw">
            <h1 className="questionSinc">Яка ваша думка?</h1>

            <div className="questionsWrap">
              <p className="descriptionQuestion">{surveys[0].description}</p>

              {surveys[0].options
                .map((option, originalIndex) => ({
                  ...option,
                  originalIndex,
                }))
                .filter((option) => option.text !== "")
                .map((option) => {
                  const percentage = totalVotes
                    ? ((Number(option.score || 0) / totalVotes) * 100).toFixed(
                        1,
                      )
                    : 0;

                  const isSelected =
                    selectedOptionIndex === option.originalIndex;

                  return (
                    <div className="QuestionUl" key={option.originalIndex}>
                      <div
                        className={`checkQuestion ${
                          isSelected
                            ? hasVoted
                              ? "greenButtonCheck"
                              : "selected"
                            : ""
                        } ${hasVoted ? "disabledQuestionOption" : ""}`}
                        onClick={() => handleOptionClick(option.originalIndex)}
                      ></div>

                      {showResults && (
                        <span className="percentage">{percentage}%</span>
                      )}

                      <p className="questionLi">{option.text}</p>
                    </div>
                  );
                })}

              {!hasVoted && (
                <button className="questionButton" onClick={handleVoteClick}>
                  Проголосувати
                </button>
              )}

              {hasVoted && (
                <p className="alreadyVotedText">
                  Ви вже проголосували в цьому опитуванні.
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Question;
